export enum TimePeriod {
  TODAY = 'TODAY',
  THIS_WEEK = 'THIS_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  ALL = 'ALL'
}

export interface FilterState {
  selectedCategory: string | null;
  selectedBudgetGroups: Set<string>;
  timePeriod: TimePeriod;
}

export function getTimePeriodRange(period: TimePeriod): { startTime: number; endTime: number } {
  const now = new Date();
  const endTime = now.getTime();
  
  let startTime: number;
  
  switch (period) {
    case TimePeriod.ALL:
      startTime = 0;
      break;
    case TimePeriod.TODAY:
      const today = new Date(now);
      today.setHours(0, 0, 0, 0);
      startTime = today.getTime();
      break;
    case TimePeriod.THIS_WEEK:
      const weekStart = new Date(now);
      const day = weekStart.getDay();
      const diff = weekStart.getDate() - day + (day === 0 ? -6 : 1); // Monday
      weekStart.setDate(diff);
      weekStart.setHours(0, 0, 0, 0);
      startTime = weekStart.getTime();
      break;
    case TimePeriod.THIS_MONTH:
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      monthStart.setHours(0, 0, 0, 0);
      startTime = monthStart.getTime();
      break;
    case TimePeriod.LAST_MONTH:
      const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      lastMonthStart.setHours(0, 0, 0, 0);
      startTime = lastMonthStart.getTime();
      // Set end time to the last moment of last month
      const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
      return { startTime, endTime: lastMonthEnd.getTime() };
    case TimePeriod.THIS_YEAR:
      const yearStart = new Date(now.getFullYear(), 0, 1);
      yearStart.setHours(0, 0, 0, 0);
      startTime = yearStart.getTime();
      break;
  }
  
  return { startTime, endTime };
}

export function getTimePeriodLabel(period: TimePeriod): string {
  switch (period) {
    case TimePeriod.TODAY:
      return 'Today';
    case TimePeriod.THIS_WEEK:
      return 'This Week';
    case TimePeriod.THIS_MONTH:
      return 'This Month';
    case TimePeriod.LAST_MONTH:
      return 'Last Month';
    case TimePeriod.THIS_YEAR:
      return 'This Year';
    case TimePeriod.ALL:
      return 'All Time';
  }
}
